import React from "react";
import "../styles/impressum.css"; // Pfad ggf. anpassen

export default function Impressum() {
  return (
    <div className="impressum-container">
      <h1>Impressum <span className="beta-hint">Beta-Version</span></h1>
      
      <section className="impressum-section">
        <strong>ReYou UG (haftungsbeschränkt) in Gründung</strong>
        <br />
        c/o Lars Röser / Philipp Brinkmann
        <br />
        Mündelheimer Weg 31
        <br />
        40472 Düsseldorf
        <br />
        Deutschland
        <br /><br />
        E-Mail: <a href="mailto:info@reyou.ai">info@reyou.ai</a>
        <br />
        Hilfe und Support: <a href="mailto:support@reyou.ai">support@reyou.ai</a>
        <br />
        Datenschutz: <a href="mailto:datenschutz@reyou.ai">datenschutz@reyou.ai</a>
        <br />
        Kündigung: <a href="mailto:kuendigung@reyou.ai">kuendigung@reyou.ai</a>
        <br />
        Telefon: <a href="tel:+49000000000">+49 000 000 000 00</a>
      </section>

      <section className="impressum-section">
        <strong>Verantwortlich nach § 55 RStV:</strong>
        <br />
        Lars Röser / Philipp Brinkmann, Anschrift wie oben
      </section>

      <section className="impressum-section">
        <strong>Hinweis zum Gründungsstatus:</strong>
        <br />
        ReYou UG (haftungsbeschränkt) befindet sich derzeit in Gründung.<br />
        Der Gesellschaftsvertrag wird zur Eintragung ins Handelsregister vorbereitet.
      </section>
    </div>
  );
}
